import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchRoutes, fetchStops, clearEditStatus, fetchUnassignedOrders, assignOrderRoute, saveEditedStops,
  generateRoute, fetchAutoRoutes, fetchAutoRouteStops, changeFormValue, updateStopsOfAutoRoutes, printPickinglist,
  changeStopIndex, printPickinglistAll,
} from '../../actions/dispatch_actions';
import { printDispatchRoute, printDispatchPickingList, printDispatchPackingList, printDispatchSalesInvoice } from '../../actions/print_actions';

import AutoRouting from '../../components/Dispatch/AutoRouting';

const AutoRoutingContainer = reduxForm({
  form: 'AutoRouting',
  // validate
})(AutoRouting);

const selector = formValueSelector('AutoRouting');

function mapStateToProps(state) {
  const dateChosen = selector(state, 'DeliverDate');
  const OrderNo = selector(state, 'OrderNo');
  const StopIndex = selector(state, 'StopIndex');
  const deleteStopIndex  = selector(state, 'deleteStopIndex');
  return {
    // dateChosen,
    OrderNo,
    StopIndex,
    deleteStopIndex,
    routes: state.dispatch.autoRoutes,
    routesIsLoading: state.dispatch.routesIsLoading,
    routesError: state.dispatch.routesError,
    buttonLoadingVisible: state.dispatch.buttonLoadingVisible,

    stops: state.dispatch.stops,
    stopsIsLoading: state.dispatch.stopsIsLoading,
    stopsError: state.dispatch.stopsError,
    savingEditedStops: state.dispatch.savingEditedStops,

    pdfFile: state.dispatch.pdfFile,
    // unassignedOrders: state.dispatch.unassignedOrders,
    // unassignedOrdersIsLoading: state.dispatch.unassignedOrdersIsLoading,
    // unassignedOrdersError: state.dispatch.unassignedOrdersError,
    // assigningOrderRoute: state.dispatch.assigningOrderRoute,
    // userPermissions: state.auth.userPermissions,

    // requestingRoutingPdf: state.print.requestingRoutingPdf,
    // routingPdf: state.print.routingPdf,
    // routingPdfFailure: state.print.routingPdfFailure,

    // requestingPickingListPdf: state.print.requestingPickingListPdf,
    // pickingListPdf: state.print.pickingListPdf,
    // pickingListPdfFailure: state.print.pickingListPdfFailure,

    // requestingPackingListPdf: state.print.requestingPackingListPdf,
    // packingListPdf: state.print.packingListPdf,
    // packingListPdfFailure: state.print.packingListPdfFailure,

    // requestingDispatchSalesInvoicePdf: state.print.requestingDispatchSalesInvoicePdf,
    // dispatchSalesInvoicePdf: state.print.dispatchSalesInvoicePdf,
    // dispatchSalesInvoicePdfFailure: state.print.dispatchSalesInvoicePdfFailure,
  };
}

export default connect(mapStateToProps, {
  // fetchRoutes,
  // fetchStops,
  fetchAutoRouteStops,
  changeFormValue,
  updateStopsOfAutoRoutes,
  changeStopIndex,
  // clearEditStatus,
  // fetchUnassignedOrders,
  // assignOrderRoute,
  // saveEditedStops,
  // printDispatchRoute,
  // printDispatchPickingList,
  // printDispatchPackingList,
  // printDispatchSalesInvoice,
  generateRoute,
  fetchAutoRoutes,
  printPickinglist,
  printPickinglistAll,
})(AutoRoutingContainer);



// WEBPACK FOOTER //
// ./master/jsx/containers/Dispatch/AutoRouting.jsx